<tec-tile [title]="'OPERATIONS.DETAIL.TABS.CHECKS.COMPARE_INFO' | translate">
    @if (detail?.data?.antifraud || detail?.data?.actions) {
        <app-operation-pol-checks-compare-info [detail]="detail" />
    } @else {
        <tec-empty-state [title]="'OPERATIONS.DETAIL.TABS.CHECKS.EMPTY' | translate" [size]="'default'" [type]="'empty'" />
    }
</tec-tile>

<tec-tile [title]="'OPERATIONS.DETAIL.TABS.CHECKS.ANTIFRAUD' | translate">
    @if (hasAntifraudContent && checksDetail) {
        @if (pol?.state) {
            <span style="display: inline-flex; gap: 6px; align-items: center; margin-bottom: 8px;">
                {{ ('PROCESSES.DETAIL.POL' | translate).toUpperCase() }}
                <tec-tag
                    [label]="'MASTER.STATUS.' + pol.state | translate"
                    [status]="masterService.getTagStatus(pol.state)"
                />
            </span>
        }
        <app-operation-pol-checks-antifraud [checksDetail]="checksDetail" [checks]="antifraudChecks" />
    } @else {
        <tec-empty-state [title]="'OPERATIONS.DETAIL.TABS.CHECKS.EMPTY' | translate" [size]="'default'" [type]="'empty'" />
    }
</tec-tile>
